require('./RAPortfolioDonut.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
// @ commons
const RAPieChart = require('components/RAComponents/commons/RAPieChart/RAPieChart');
// @ utilities
const { formatPercentageWithDecimals } = require('utilities/RACurrencyHelper');
const RAAssetsHelper = require('utilities/RAAssetsHelper');
// @ constants
const {
    ACTIVE_CLASS_EQUITY_ID,
    ACTIVE_CLASS_FIXED_INCOME_ID,
    ACTIVE_CLASS_MONEY_MARKET_ID,
    ACTIVE_CLASS_REAL_ASSETS_ID,
    PERCENTAGE_SYMBOL,
} = require('constants/RAConstants/index');

class RAPortfolioDonut extends React.Component {
    getBarClassName(assetClassId) {
        const customClass = classNames('ra-portfolio-donut__bar', {
            ['ra-portfolio-donut__bar--money-market']: assetClassId === ACTIVE_CLASS_MONEY_MARKET_ID,
            ['ra-portfolio-donut__bar--fixed-income']: assetClassId === ACTIVE_CLASS_FIXED_INCOME_ID,
            ['ra-portfolio-donut__bar--equity']: assetClassId === ACTIVE_CLASS_EQUITY_ID,
            ['ra-portfolio-donut__bar--real-assets']: assetClassId === ACTIVE_CLASS_REAL_ASSETS_ID,
        });

        return customClass;
    }

    buildDonutChart(immAssetAllocations) {
        const assetAllocationsDonutData = immAssetAllocations.map(asset => ({
            name: asset.get('assetClass'),
            value: asset.get('weight'),
            fill: RAAssetsHelper.getBarColor(asset.get('assetClassId')),
        }));

        return (
            <div className="ra-portfolio-donut__item">
                <RAPieChart data={assetAllocationsDonutData} />
            </div>
        );
    }

    buildDistributionSubAssetsItems(subAssets) {
        const subAssetItemBlock = subAssets.map(subAsset => (
            <div key={subAsset.get('subAssetClassId')} className="ra-portfolio-donut__sub-item">
                <span className="ra-portfolio-donut__sub-item-label">{subAsset.get('subAssetClass')}</span>
                <span className="ra-portfolio-donut__sub-item-value">
                    {formatPercentageWithDecimals(subAsset.get('weight'), false)}
                </span>
                <span className="ra-portfolio-donut__sub-item-symbol-label">{PERCENTAGE_SYMBOL}</span>
            </div>
        ));

        return subAssetItemBlock;
    }

    buildDistributionAssetsTabs(immAssetAllocations) {
        const assetsTabsBlock = immAssetAllocations.map(assetAllocation => {
            const assetClassId = assetAllocation.get('assetClassId');
            const barClassName = this.getBarClassName(assetClassId);
            const subAssetClasses = assetAllocation.get('subAssetClasses', assetAllocation.get('subAssetAllocations'));
            const subAssetsItemsBlock = this.buildDistributionSubAssetsItems(subAssetClasses);
            const percentage = formatPercentageWithDecimals(assetAllocation.get('weight'), false);
            let assetClass = assetAllocation.get('assetClass');
            if (assetClass == 'Mercado Monetario' && screen.width < 480) {
                assetClass = 'Monetarios';
            }

            return (
                <div key={assetClassId} className="ra-portfolio-donut__tab-item">
                    <div className="ra-portfolio-donut__item-container">
                        <div className="ra-portfolio-donut__item-title-label">{assetClass}</div>
                        <div className="ra-portfolio-donut__item-container-percent">
                            <span className="ra-portfolio-donut__item-percent-label">{percentage}</span>
                            <span className="ra-portfolio-donut__item-symbol-label">{PERCENTAGE_SYMBOL}</span>
                        </div>
                        <div className="ra-portfolio-donut__sub-items">
                            <div className="dropdown-sub-items">{subAssetsItemsBlock}</div>
                        </div>
                        <div className={barClassName} />
                    </div>
                </div>
            );
        });

        return assetsTabsBlock;
    }

    render() {
        const { immAssetAllocations } = this.props;
        const donutChartBlock = this.buildDonutChart(immAssetAllocations);
        const distributionAssetsTabsBlock = this.buildDistributionAssetsTabs(immAssetAllocations);

        return (
            <div className="ra-portfolio-donut">
                <div className="ra-portfolio-donut__tabs">
                    {donutChartBlock}
                    <div className="ra-portfolio-donut__items">{distributionAssetsTabsBlock}</div>
                </div>
            </div>
        );
    }
}

RAPortfolioDonut.propTypes = {
    immAssetAllocations: PropTypes.object.isRequired,
};

module.exports = RAPortfolioDonut;
